import { fork, call, select, put } from 'redux-saga/effects';

import { actions, selectors } from 'domain/customer';
import { filters } from 'filters/customer';
import {
  actions as enterpriseActions,
  selectors as enterpriseSelectors,
} from 'domain/enterprise';
import { loadSingleData } from 'sagas/common';
import { listNavigator } from 'sagas/common';
import { getLocation } from 'domain/router';
import { selectors as customerSelectors } from 'domain/customer';
import Api, { callApi } from 'domain/api';
import { checkQuery } from 'lib/helpers';

// Custom function to load Enterprise data with pageSize 100 (isolated from other API calls)
function* loadEnterpriseListData(
  { modelName, actions: { fetchListAction, selectAction }, filters, selectors },
  resetChecked = true,
  callback
) {
  const { id: userId } = yield select(customerSelectors.item);
  const apiKey = !!userId
    ? `getCustomer${modelName}List`
    : `get${modelName}List`;

  // Create isolated query specifically for Enterprise with pageSize 100
  // Don't use global query to avoid affecting other API calls
  const enterpriseQuery = { pageSize: 999999, page: 1 };

  yield put({ type: fetchListAction.request });
  if (resetChecked) yield put(selectAction(null));

  try {
    const location = yield select(getLocation);
    const { data } = yield callApi(Api[apiKey], {
      userId,
      query: checkQuery(enterpriseQuery, filters),
    });

    if ((yield select(getLocation)) === location) {
      yield put({
        type: fetchListAction.success,
        payload: {
          ...data,
          list: data.list,
          pagination: {
            ...data.pagination,
            pages: Math.ceil(data.pagination.total / enterpriseQuery.pageSize),
            page: enterpriseQuery.page,
            pageSize: enterpriseQuery.pageSize,
          },
        },
      });

      if (typeof callback === 'function') yield fork(callback, data);
    }
  } catch (e) {
    console.error(e);
  }
}

export default function* navigator() {
  yield call(loadSingleData, {
    modelName: 'SeatTypes',
    actions: actions,
    id: 1,
    initForm: false,
  });
  yield call(
    loadEnterpriseListData,
    {
      modelName: 'Enterprise',
      actions: enterpriseActions,
      selectors: enterpriseSelectors,
      filters: {},
    },
    false
  );
  yield fork(listNavigator, {
    modelName: 'Customer',
    actions,
    selectors,
    filters,
  });
}
